import { Group } from '../models/group.model';
import { SettingsResult } from '../models/game-settings.model';

export class GroupsService {

  private availableLabels = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  private availableColors = [
    '#8BB89A',
    '#A25F58',
    '#4B7E97',
    '#575242',
    '#F1D880',
    '#727777',
    '#C2BC9E',
    '#DEB1AD',
    '#BCD4E6',
    '#816699',
    '#C68C5D',
    '#324B3A'];


  groups: Group[];
  groupItems: Group[];

  defaultAmountGroups = 8;

  constructor() {
    console.log('GroupsService constructor');
    this.groups = [];
    this.groupItems = [];

    this.initWithDefaults();
  }

  initWithDefaults() {
    this.groups = [];
    this.groupItems = [];

    console.log('GroupsService initWithDefaults');
    this.createGroups(12); // max amount, based on selected colors
  }

  initWithSettings(settings: SettingsResult) {

    console.log('GroupsService initWithSettings');
    this.groups = [];
    this.groupItems = [];

    console.log(settings);

    this.createGroups(12); // max amount, based on selected colors

    for (let i = 0; i < settings.groupArray.length; i++) {
      const item = settings.groupArray[i];
      this.groupItems.push(item);

      // Also needs a shift to keep track of groups
      this.groups.shift();
    }

    console.log(this.groupItems);
  }

  createGroups(amount: number) {
    this.groups = [];

    console.log('Creating groups');

    for (let i = 0; i < amount; i++) {
      this.createGroup(i);
    }
  }

  addItem(): Group {
    const item = this.groups.shift();
    this.groupItems.push(item);
    return item;
  }

  removeItem(): Group {
    const item = this.groupItems.pop();
    this.groups.unshift(item);
    return item;
  }

  private getColor(index: number): string {
    return this.availableColors[index];
  }

  private getLabel(index: number): string {
    return this.availableLabels[index];
  }

  private createGroup(index: number): Group {
    const label = this.getLabel(index);
    const name = label;
    const color = this.getColor(index);
    const group: Group = {id: index, label: label || 'A', color: color || '#0089A8', name: name || ''};
    this.groups.push(group);
    return group;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/groups-service.ts